import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { User } from '../model/user';
import { AuthService } from './auth.service';
import { Buffer } from 'buffer';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private cookieService: CookieService) {

  }

  public toasterMessage = new Subject<any>;
  public currentMessage = this.toasterMessage.asObservable();

  public getRetentionPeriodDateRange(): any {
    let currentDate = new Date();
    const throughYear: number = currentDate.getFullYear();
    const fromYear: number = throughYear - 7;
    return {
      fromYear: fromYear,
      throughYear: throughYear
    }
  }

  changeMessage(message: any){
    this.toasterMessage.next(message);
  }

  getMessage(){
    return this.toasterMessage.asObservable();
  }

  public getUserData(): User {
    let encodedData = this.cookieService.get(AuthService.userDataKey);
    let decodedData = Buffer.from(encodedData, "base64").toString("utf-8");
    let xbc_userData: User = JSON.parse(decodedData);
    return xbc_userData;
  }

}
